import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import NavBar from "./components/NavBar/NavBar";
import AboutUs from "./pages/AboutUs/AboutUs";
import Services from "./pages/Service/Services";
import GetInvolved from "./pages/GetInvolved/GetInvolved";
import ContactUs from "./pages/ContactUs/ContactUs";
import Careers from "./pages/Careers";

import Register from "./components/Register/Register";
import SignIn from "./components/SignIn/SignIn";
import Privacy from "./components/Privacy/privacy";
import TermsOfService from "./pages/TermsOfService/TermsOfService";
import UserDataDeletion from "./pages/UserDataDeletion/UserDataDeletion";
import { Toaster } from "react-hot-toast";
import GlobalVoiceAgent from "./components/VoiceAgent/GlobalVoiceAgent";
import SharedAgent from "./pages/SharedAgent/SharedAgent";
import RouteTracker from "./components/RouteTracker/RouteTracker";
import "./App.css";

function App() {
  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <Router>
        <RouteTracker />
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/getinvolved" element={<GetInvolved />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/register" element={<Register />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/user-data-deletion" element={<UserDataDeletion />} />
          <Route path="/data-deletion" element={<UserDataDeletion />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/agent/:agentId" element={<SharedAgent />} />
        </Routes>
        
        {/* Chauwk Website Agent - Exotel voice server widget (ExotelVoiceWidget) */}
        {/* We conditionally render this globally if needed, or disable it on /agent routes. */}
        <GlobalVoiceAgent />
      </Router>

    </div>
  );
}

export default App;

